import { createContext, useContext } from 'react';

export type SideDrawerBaseContextType = {
  headingId?: string;
};

export const SideDrawerBaseContext = createContext<SideDrawerBaseContextType | null>(
  null
);

export const useSideDrawerBase = () => {
  const context = useContext(SideDrawerBaseContext);

  if (!context) {
    throw Error('useSideDrawerBase must be used inside SideDrawer');
  }

  return context;
};
